module.exports = __webpack_public_path__ + "img/settings.1d2d86b6.svg";